import { EARN_VIA_ACTION } from '../../constants/actions'

const getUGC = () => ({
  type: EARN_VIA_ACTION.GET_UGC
})

const getStats = () => ({
  type: EARN_VIA_ACTION.GET_STATS
})

const getUsernameByTID = (tid) => ({
  type: EARN_VIA_ACTION.GET_USERNAME_BY_TID,
  payload: { tid }
})

const changeEarnViaState = (property, value) => ({
  type: EARN_VIA_ACTION.CHANGE_STATE,
  payload: {
    property,
    value
  }
})

const connectSocialAccount = (brandId) => ({
  type: EARN_VIA_ACTION.GET_URL_FOR_SOCIAL_CONNECT,
  payload: { brandId }
})

const handleSocialLoginStatus = (brandId, data) => ({
  type: EARN_VIA_ACTION.HANDLE_SOCIAL_LOGIN_STATUS,
  payload: { brandId, data }
})

export {
  changeEarnViaState,
  connectSocialAccount,
  getStats,
  getUGC,
  getUsernameByTID,
  handleSocialLoginStatus
}
